import { Modal, Button, Spinner } from "react-bootstrap";
import { Form, Link } from "react-router-dom";
import "./Modal.scss";
import { useSelector } from "react-redux";
import { useState } from "react";
import httpApiCall from "../service/api.service";
import toastr from "../components/elements/toast";

const WriteToUs = (props: any) => {
  const [show, setShow] = useState(false);
  const toastrService = new toastr(true);
  const answer = useSelector((state: any) => state?.APIData?.partnerData);
  const [note, setNote] = useState("");
  const [sppiner, setSppiner] = useState(false);
  const submitQuiry = async () => {
    if (!note || note.length < 1) {
      toastrService.showError("Please enter a message");
      return;
    }
    setSppiner(true)
    let body = {
      access_token: answer?.partner_profile[0]["access_token"],
      type: 3,
      name: answer?.partner_profile[0]["partner_name"],
      phone: answer?.partner_profile[0]["partner_mobile"],
      phone_country_code:
        answer?.partner_profile[0]["partner_mobile_country_code"],
      country_code: answer?.partner_profile[0]["partner_mobile_country_code"],
      src_url: "Inquiry made from Partner Panel " + window.location.href,
      message: note,
      specialty: "N.A.",
      zip: answer?.partner_profile[0]["zip"]
        ? answer.partner_profile[0]["zip"]
        : "N.A.",
      address: answer?.partner_profile[0]["partner_address"]
        ? answer.partner_profile[0]["partner_address"]
        : "N.A.",
      email: answer?.partner_profile[0]["partner_email"],
    };
    await httpApiCall({ api: "add_wp_contact_query", type: "POST", body })
      .then((data) => {
        setSppiner(false)
        if (data && !data.is_error) {
          // console.log(data);
          toastrService.showSuccess("Message sent successfully");
          props.onHide();
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-center"
        centered
        className="writetous"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h1>Write to Us</h1>
            <p>Please describe your query</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="textarea">
            <textarea
              name="writeToUsMessage"
              id=""
              cols={30}
              rows={10}
              placeholder="Enter your message here"
              onChange={(e) => setNote(e.target.value)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={submitQuiry} className="send_data">Send Message {sppiner && (
                                              <Spinner
                                                className="ml-2"
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                            )}</Button>
          <Button onClick={props.onHide}>Cancel</Button>
        </Modal.Footer>
        <p className="note_submit">
          By submitting your information, you agree to our{" "}
          <Link to="https://credee.com/privacy-policy/" target="_blank">
            Privacy policy
          </Link>
          . By providing your contact information you are giving Credee
          Corporation (
          <Link to="https://credee.com/" target="_blank">
            credee.com
          </Link>
          ) permission to contact you about this and future offers using the
          information provided. You are providing Credee Corporation and third
          parties 
          {show && (
            <span className="mb-0">consent to contact you through emails, calls, and text
            messages to your wireless telephone numbers. You understand contact
            may also include but is not limited to, using an automated dialing
            device and prerecorded messages.</span>
          )} 
          <div className="showmsg" onClick={() => setShow(!show)}> { show ? "ShowLess" : " ShowMore"}</div>
        </p>
      </Modal>
    </div>
  );
};
export default WriteToUs;
